<template>
  <ul class="navigation" v-sticky="{ zIndex: 5, stickyTop: 55, disabled: $vuetify.breakpoint.smAndDown }">
    <li
      v-for="sectionPage in sectionPages"
      v-if="sectionPage.visible"
      :key="sectionPage.uid">
      <a
        :href="`#${sectionPage.uid}`"
        :class="{ 'active': active[sectionPage.uid] }"
        class="no-underline"
        @click="onClick(sectionPage, $event)"
        v-scroll-to="{ el: `#${sectionPage.uid}`, offset: -offset }">
        <i>{{sectionPage.title}}</i>
      </a>
    </li>
  </ul>
</template>
<script>
import VueSticky from 'vue-sticky'
// import { getPath } from '@/util'

export default {
  props: {
    sectionPages: {
      type: Array
    },
    drawerOpen: {
      type: Boolean
    }
  },
  directives: {
    'sticky': VueSticky
  },
  data () {
    return {
      active: {},
      sections: []
    }
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  mounted () {
    this.sections = document.querySelectorAll('.content-column > section')
    this.onScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  computed: {
    offset () {
      return 0
    }
  },
  methods: {
    onClick (sectionPage, event) {
      // if you click on the navigation container, it takes you
      // back home
      event.stopPropagation()

      // TODO: Remove, might go back to this.
      // directly open drawer if the navigation item has
      // subpages
      // if (sectionPage.children.length) {
      //   this.$router.push(getPath(sectionPage.url))
      //   return
      // }

      this.$router.push('/')
    },
    resetActive () {
      for (let prop in this.active) {
        if (this.active.hasOwnProperty(prop)) {
          this.$set(this.active, prop, false)
        }
      }
    },
    onScroll (event) {
      const top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
      this.resetActive()

      // if this is the last section and we've scrolled to the bottom,
      // activate it no matter what
      // https://stackoverflow.com/questions/9439725/javascript-how-to-detect-if-browser-window-is-scrolled-to-bottom
      let i = this.sections.length
      const isScrolledToBottom = (window.innerHeight + window.scrollY) >= document.body.scrollHeight
      if (isScrolledToBottom) {
        this.$set(this.active, this.sections[i - 1].id, true)
        return
      }

      // set acive based on url part
      while (i--) {
        const url = this.sections[i].dataset.url
        if (!url) {
          continue
        }

        const re = new RegExp(`^${url}`)
        if (re.test(window.location.href)) {
          this.$set(this.active, this.sections[i].id, true)
          return
        }
      }

      // if that fails, set by scroll location
      i = this.sections.length
      while (i--) {
        let rect = this.sections[i].getBoundingClientRect()
        const sectionTop = parseInt(rect.top + window.scrollY, 10)

        // NB: if we're above the first section, make that active
        // if ((rect.top - this.offset) + window.scrollY < top || (i === 0 && (rect.top - this.offset) + window.scrollY > top)) {
        if (sectionTop <= top || (i === 0 && sectionTop > top)) {
          this.$set(this.active, this.sections[i].id, true)
          break
        }
      }
    }
  }
}
</script>
<style lang="stylus">
@require '~vuetify/src/stylus/settings/_variables'

.navigation
  min-width: 260px
  li
    padding-left: 0
    &:before
      display: none
  a.active
    text-transform uppercase !important
  a:hover,
    text-transform uppercase
    @media $display-breakpoints.sm-and-down
      text-transform inherit

// https://stackoverflow.com/questions/25014141/positionfixed-sliding-bug-in-chrome-mobile
.v-dialog__content
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  height 100vh !important
</style>
